import { Typography } from '@telus-uds/components-web'
import useTranslate from '../../../hooks/useTranslate'

const PageHeading = () => {
  const t = useTranslate()
  return (
    <Typography testID="heading1" heading="h1" variant={{ size: 'h1' }}>
      {t('banner.title')}
    </Typography>
  )
}

export default PageHeading
